import {
  DownloaderRepository,
  HttpModel,
  IFile,
  LegalDocumentType,
} from '@/Shared/domain'

interface IDownloaderContract {
  downloadLegalDocument: (
    legalDocumentType: LegalDocumentType,
  ) => Promise<HttpModel<IFile>>
  downloadPublicDocument: (
    legalDocumentType: LegalDocumentType,
  ) => Promise<HttpModel<IFile>>
}

export const DownloaderContract = (
  downloaderRepository: DownloaderRepository,
): IDownloaderContract => ({
  downloadLegalDocument: async (
    legalDocumentType: LegalDocumentType,
  ): Promise<HttpModel<IFile>> => {
    return await downloaderRepository.DownloadLegalDocument(legalDocumentType)
  },
  downloadPublicDocument: async (
    legalDocumentType: LegalDocumentType,
  ): Promise<HttpModel<IFile>> => {
    return await downloaderRepository.DownloadPublicDocument(legalDocumentType)
  },
})
